import React, { Suspense } from "react";
import { useGetDailySpecialsQuery } from "@/store/api/productApi";
import DailySpecialCard from "./DailySpecialCard";
import Spinner from "../loader/Spinner";
import ProductCardSkeleton from "./ProductCardSkeleton";

interface DailySpecialSectionProps {
  branchId: string;
}

const DailySpecialSection: React.FC<DailySpecialSectionProps> = ({
  branchId,
}) => {
  const { data, isLoading, error } = useGetDailySpecialsQuery(
    { branchId },
    { skip: !branchId },
  );

  // Don't render anything if loading, error, or no specials
  if (isLoading) {
    return (
      <div className="mb-8">
        <div className="flex items-center gap-2 mb-4">
          <span className="text-2xl">🔥</span>
          <p className="text-2xl font-bold">Today's Specials</p>
        </div>
        <div className="md:flex md:justify-between md:flex-wrap md:w-full">
          {[...Array(2)].map((_, idx) => (
            <div key={idx} className="md:w-[48%] mb-4">
              <ProductCardSkeleton />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error || !data || data.count === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      {/* Section Header */}
      <div className="flex items-center gap-2 mb-4">
        <span className="text-2xl">🔥</span>
        <p className="text-2xl font-bold">{data.day_name} Specials</p>
      </div>

      {/* Specials Grid */}
      <div className="md:flex md:justify-between md:flex-wrap md:w-full">
        {data.specials.map((special) => (
          <div key={special.id} className="md:w-[48%] mb-4">
            <Suspense fallback={<Spinner />}>
              <DailySpecialCard
                special={special}
                branchId={parseInt(branchId)}
              />
            </Suspense>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DailySpecialSection;
